<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-velda-languages-subnav></app-velda-languages-subnav>
    </app-sidebar>

    <app-content>
        <div class="app__title">
            <h1>Languages overview</h1>
            <span>
                <a
                    (click)="openAddLanguageModal()"
                    *appIsPermitted="{
                        module: 'VELDA_LANGUAGES',
                        operator: 'AND',
                        actions: ['CREATE']
                    }"
                    class="button button--primary"
                    >Add language</a
                >
            </span>
        </div>

        <app-velda-languages-languages-list
            *appIsPermitted="{
                module: 'VELDA_LANGUAGES',
                operator: 'AND',
                actions: ['READ']
            }"></app-velda-languages-languages-list>
    </app-content>
</app-app-holder>
